<template>
    <main class="px-4 max-w-screen-xl mx-auto">
        <NsFeatureHeroSection />
        <NsServicesSection />
        <NsPreBuiltSection />
        <NsHighlightSection />
    </main>
</template>

<script setup lang="ts">

const NsFeatureHeroSection = defineAsyncComponent(() => import('~/components/NsFeatureHeroSection.vue'));
const NsPreBuiltSection = defineAsyncComponent(() => import('~/components/NsPreBuiltSection.vue'));
const NsServicesSection = defineAsyncComponent(() => import('~/components/NsServicesSection.vue'));
const NsHighlightSection = defineAsyncComponent(() => import('~/components/NsHighlightSection.vue'));

useHead({
  title: 'Features - Nuxt.store E-commerce Platform',
  meta: [
    {
      name: 'description',
      content: 'Discover the powerful features of Nuxt.store including SEO optimization, responsive design, multi-language support, wishlist, reviews, multi-vendor support, and more.'
    }
  ]
})
</script>
